import Axios from 'axios';

const axios = Axios.create();

export {axios};
